import { useSelector } from 'react-redux';
import type { IReduxState } from '@frontend/configureStore';
import { useLocalStorage } from '@frontend/utils/hooks/useLocalStorage';

export function useUserLocalStorage<T>(key: string, initialValue: T): [T, (value: T) => void] {
    const { id } = useSelector((state: IReduxState) => state.authentication);
    const localStorageKey = `${id}_${key}`;

    return useLocalStorage(localStorageKey, initialValue);
}
